<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :col="3"
      :columns="tableColumns"
      :queryParams="queryParams"
      :searchOptions="tableSearchOptions"
      :requestPromise="loadData?loadData:loadDataList"
    >
    </StandardSearchPageView>
  </div>
</template>

<script>
import SearchMixins from '../../mixins/SearchMixins'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ZwyMiXins from '@/views/resource/zwy/mixins/ZwyMiXins'

export default {
  name: 'OrderRecordsComponent',
  mixins:[SearchMixins,ZwyMiXins],
  props:{
    proJoinType:{
      type:String,
      default:''
    },
    columns:{
      type:Array,
      default:()=>[]
    },
    searchOptions:{
      type:Array,
      default:()=>[]
    },
    loadData:{
      type:Function,
      default:undefined
    }
  },
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {
      },
      localSearchOptions: [
        {
          name: '订单编号',
          key: 'orderNo',
          type: 'input',
          placeholder: '请输入订单编号'
        },
        {
          name: '产品名称',
          key: 'proName',
          type: 'input',
          placeholder: '请输入产品名称'
        },
        {
          name: '自我游订单号',
          key: 'zwyOrderId',
          type: 'input',
          placeholder: '请输入自我游订单号',
        },
        // {
        //   name: '自我游类目',
        //   type: 'select',
        //   key: 'proJoinType',
        //   placeholder: '请选择',
        //   selectOptions: []
        // },
        {
          name: '更新日期',
          key: 'startDate,endDate',
          type: 'rangePicker',
        },
      ]
    }
  },
  // watch: {
  //   'joinTypeList':function () {
  //     const thirdOption = this.searchOptions[3]
  //     thirdOption.selectOptions=this.joinTypeList
  //     this.$set(this.searchOptions,3,thirdOption)
  //   },
  // },
  computed:{
    tableColumns(){
      return this.columns&&this.columns.length>0?this.columns:this.getColumns()
    },
    tableSearchOptions(){
      return this.searchOptions&&this.searchOptions.length>0?this.searchOptions:this.localSearchOptions
    }
  },
  methods: {
    loadDataList(params) {
      const requestParams = this.getRequestParams(params)
      requestParams.proJoinType=this.proJoinType;
      return this.getHttpServices().getSourceService().post('zwy/order/list',requestParams)
    },
    getColumns(){
      return [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '120px',
        },
        {
          title: '自我游订单号',
          dataIndex: 'zwyOrderId',
          width: '120px',
        },
        {
          title: '产品名称',
          dataIndex: 'proName',
          width: '400px'
        },
        {
          title: '订单状态',
          dataIndex: 'statusName',
          width: '120px',
        },
        {
          title: '自我游类目',
          dataIndex: 'proJoinTypeName',
          width: '120px',
        },
        {
          title: '订单来源',
          dataIndex: 'viewName',
          width: '160px',
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime',
          width: '160px'
        }
      ]
    },
  }
}
</script>

<style scoped></style>
